import { useCallback, useState } from "react";
import { fetchAllClients } from "../../../services/clients.service";

/** Lazily loads the full client list (used by the "Link Existing" client picker). */
export function useAllClients() {
  const [allClients, setAllClients] = useState<any[]>([]);
  const [loadingClients, setLoadingClients] = useState(false);
  const [clientsLoaded, setClientsLoaded] = useState(false);

  const loadAllClients = useCallback(async () => {
    if (clientsLoaded || loadingClients) return;
    setLoadingClients(true);
    try {
      const resp: any = await fetchAllClients();
      setAllClients(Array.isArray(resp) ? resp : []);
      setClientsLoaded(true);
    } catch {
      // silently fail — user can still type a new client name
    } finally {
      setLoadingClients(false);
    }
  }, [clientsLoaded, loadingClients]);

  const resetClients = () => {
    setClientsLoaded(false);
    setAllClients([]);
  };

  return { allClients, loadingClients, loadAllClients, resetClients };
}
